"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveBotConfig = void 0;
const resolveBotConfig = (ctx, botName) => {
    const { [botName]: botConfig = undefined } = ctx.resourcesConfig.Interactions?.LexV1 ?? {};
    if (botConfig !== undefined) {
        return { ...botConfig, name: botName };
    }
};
exports.resolveBotConfig = resolveBotConfig;
